import { render, staticRenderFns } from "./banSomeChat.vue?vue&type=template&id=69b4382e&"
import script from "./banSomeChat.vue?vue&type=script&lang=js&"
export * from "./banSomeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b4382e')) {
      api.createRecord('69b4382e', component.options)
    } else {
      api.reload('69b4382e', component.options)
    }
    module.hot.accept("./banSomeChat.vue?vue&type=template&id=69b4382e&", function () {
      api.rerender('69b4382e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banSomeChat.vue"
export default component.exports